import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'TypesCveList' })({
    content: {
        marginTop: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 24
    },
    spinner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 36,
        paddingBottom: 36
    },
    button: {
        textTransform: 'uppercase',
        padding: '10px 16px',
        border: 'none !important',
        minWidth: '105px !important',
        borderRadius: 12,
        background: '#F8F8F8 !important',
        color: '#232323 !important'
    },
    _active: {
        pointerEvents: 'none',
        background: '#232323 !important',
        color: '#F8F8F8 !important'
    }
});
